import { render } from "./preferences.vue?vue&type=template&id=1f405084"
import script from "./preferences.vue?vue&type=script&lang=js"
export * from "./preferences.vue?vue&type=script&lang=js"

import "./preferences.vue?vue&type=style&index=0&id=1f405084&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__